import Base from './Base';
import React from 'react';
import { PostBody } from 'js/social/News/Body';
import styled from 'astroturf/react';
import { Button } from 'js/social/shared/design_system/Button';
import _RemovedNoticeBase from "RemovedItemNotice-RemovedNoticeBase.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/RemovedItemNotice.tsx?styleId=RemovedNoticeBase";
import _RemovedPostBody from "RemovedItemNotice-RemovedPostBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/RemovedItemNotice.tsx?styleId=RemovedPostBody";
import _ContentContainer from "RemovedItemNotice-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/RemovedItemNotice.tsx?styleId=ContentContainer";


const RemovedNoticeBase = /*#__PURE__*/styled(Base, null, {
  displayName: "RemovedNoticeBase",
  styles: _RemovedNoticeBase
});

const RemovedPostBody = /*#__PURE__*/styled(PostBody, null, {
  displayName: "RemovedPostBody",
  styles: _RemovedPostBody
});

const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

interface RemovedItemNoticeProps {
  undoRemoval: () => void;
}

export const RemovedItemNotice = ({
  undoRemoval,
}: RemovedItemNoticeProps): JSX.Element => {
  return (
    <RemovedNoticeBase
      header={''}
      content={
        <ContentContainer>
          <div>
            <strong>Thanks for your feedback</strong>
            <RemovedPostBody
              content={'You won’t see this post in your feed again.'}
            />
          </div>
          <Button onClick={undoRemoval} variant={'text'}>
            Undo
          </Button>
        </ContentContainer>
      }
    />
  );
};
